// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import {
  height: calc(100vh - 72px);
  overflow: auto;
  width: 100%; }

.download-btn {
  float: right;
  border-color: #1890ff; }

@media all and (max-width: 1024px) {
  .import {
    padding: 40px 24px !important; } }

@media all and (max-width: 768px) {
  .import {
    padding: 24px !important; } }
`, "",{"version":3,"sources":["webpack://./src/pages/import/import.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,cAAc;EACd,WAAW,EAAA;;AAEf;EACI,YAAY;EACZ,qBAAqB,EAAA;;AAGzB;EACI;IACI,6BAA6B,EAAA,EAChC;;AAGL;EACI;IACI,wBAAwB,EAAA,EAC3B","sourcesContent":[".import {\n    height: calc(100vh - 72px);\n    overflow: auto;\n    width: 100%;\n}\n.download-btn {\n    float: right;\n    border-color: #1890ff;\n}\n\n@media all and (max-width: 1024px) {\n    .import {\n        padding: 40px 24px !important;\n    }\n}\n\n@media all and (max-width: 768px) {\n    .import {\n        padding: 24px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
